var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"opacity":"0.3","value":_vm.visible}},[_c('div',{staticClass:"d-flex d-flex-column justify-center"},[_c('v-progress-circular',{attrs:{"width":8,"size":"64","indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }